import { render } from "./CreateFeature.vue?vue&type=template&id=d4a904e2"
import script from "./CreateFeature.vue?vue&type=script&lang=js"
export * from "./CreateFeature.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/roshdfarms-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__